<ng-container *ngIf="discountPercentageValueProp">
  <div class="paymentRateDiscount__cont">
    <app-ds-tag-member
      [size]="tagMemberSize"
      [type]="tagMemberType$ | async"
      [style]="tagMemberStyle"
      [label]="'PRICE_OFF' | transloco : { percentage: discountPercentageValueProp }"
      [strikethrough]="{
        Value: (strikethroughValueProp | currencyFormat : currencyCode : htmlFormatByCurrency : displayCurrencyCode),
        Align: 'left',
        ShowIcon: false
      }">
    </app-ds-tag-member>
  </div>
</ng-container>
